var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrapi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 252,
    viewBox: "0 0 256 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.868 0H81.6133V84.362H164.403C167.352 84.362 169.745 86.7547 169.745 89.7042V171.351H255.211V5.35198C255.213 3.93344 254.652 2.57212 253.649 1.56815C252.647 0.564176 251.287 0 249.868 0Z",
    fill: "#8E75FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.405,
    d: "M81.6032 0V84.362H2.67132C1.58669 84.3601 0.610498 83.7036 0.19957 82.6998C-0.211358 81.6961 0.0242672 80.5435 0.796179 79.7816L81.6032 0ZM174.296 251.221C173.527 251.975 172.381 252.196 171.388 251.78C170.394 251.364 169.747 250.393 169.745 249.316V171.351H255.21L174.296 251.211V251.221Z",
    fill: "#8E75FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.405,
    d: "M81.6035 84.3623H167.079C168.544 84.3623 169.745 85.5538 169.745 87.0285V171.351H86.9555C84.0051 171.351 81.6133 168.96 81.6133 166.009V84.3623H81.6035Z",
    fill: "#8E75FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrapi);
export default __webpack_public_path__ + "static/media/strapi.ac0a6e671569cdfe3016a823859aeca2.svg";
export { ForwardRef as ReactComponent };